import { SvgIcon } from '@admin/shared/components/icons/svg-icon';
import type { SvgIconComponentProps } from '@admin/shared/components/icons/svg-icon';
import { Themes, useThemeName } from '@admin/shared/themes/themes';

/**
 * Loader Icon.
 * (used in loading indicator components)
 *
 * @param {SvgIconComponentProps} props - svg component props.
 *
 * @returns {JSX.Element}
 */
export const LoaderIcon = (props: SvgIconComponentProps): JSX.Element => {
  const name = useThemeName();

  if (name === Themes.USERLIKE) {
    return (
      <SvgIcon name="UserlikeLoaderIcon" viewBox="0 0 24 24" {...props}>
        <path
          d="M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 12.5523 20.4477 13 21 13C21.5523 13 22 12.5523 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C13.8013 22 15.5117 21.5229 16.9911 20.689C17.9261 20.1619 18.7701 19.4915 19.4878 18.707C19.8606 18.2995 19.8325 17.667 19.425 17.2942C19.0175 16.9214 18.385 16.9495 18.0122 17.357C17.4382 17.9844 16.7611 18.5227 16.0089 18.9467C14.8195 19.6172 13.446 20 12 20Z"
          fill="currentColor"
        />
      </SvgIcon>
    );
  }

  return (
    <SvgIcon name="OMQLoaderIcon" {...props} viewBox="0 0 48 48">
      <ellipse
        cx="24"
        cy="24"
        rx="17.544"
        ry="17.544"
        fill="none"
        stroke="currentColor"
        strokeOpacity="0.25"
        strokeWidth="6.85714"
      />
      <path
        d="M23.8785 6.45637C28.5314 6.42416 33.0065 8.2416 36.3193 11.5089C39.6322 14.7762 41.5114 19.2257 41.5436 23.8785"
        fill="none"
        stroke="url(#paint0_linear_126_5)"
        strokeWidth="6.85714"
        strokeLinecap="round"
        strokeDasharray="1.23 1.23"
      />
      <defs>
        <linearGradient
          id="paint0_linear_126_5"
          x1="39.1459"
          y1="32.8541"
          x2="8.85414"
          y2="15.1458"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="currentColor" />
          <stop offset="0.755208" stopColor="currentColor" stopOpacity="0.01" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};
